import { useCallback, useRef, useEffect } from 'react';

// 自定义节流 Hook
export default function useThrottle(callback, delay) {
  // 使用 useRef 保存定时器的引用
  const timeoutRef = useRef(null);
  // 使用 useRef 保存上次执行回调的时间戳
  const lastExecRef = useRef(0);

  // 清理函数 组件卸载时清理定时器
  useEffect(
    () => () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    },
    [],
  );

  // 使用 useCallback 创建一个记忆化的回调函数
  return useCallback(
    (...args) => {
      const now = Date.now();
      const timeSinceLast = now - lastExecRef.current;

      // 如果时间间隔超过或等于设定的延迟，执行回调
      if (timeSinceLast >= delay) {
        callback(...args); // 执行传入的回调函数
        lastExecRef.current = now; // 更新上次执行时间
      }
    },
    [callback, delay],
  );
}
